import React, { Fragment, useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import RecentActivityCard from './recent-activity-card';
import './styles.scss';

import InfiniteScroll from 'react-infinite-scroll-component';
import useDashboardContext from 'contexts/dashboard.context';
import PageText from 'components/base/page-text';

const RecentActivities = () => {
  const { activeCokitchen } = useDashboardContext();
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const getAllRecentActivities = async (isNew?: boolean) => {
    try {
      const res = await apiService.post('brands/brand_activity/all', {
        data: {
          page: page.toString(),
          cokitchen_id: activeCokitchen.id
        }
      });
      setTotalPages(res.data.numberOfPages);
      const allActivities = isNew ? res.data.data : [...activities, ...res.data.data];
      setActivities(allActivities);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeCokitchen.id) getAllRecentActivities(true);
  }, []);

  useEffect(() => {
    if (page > 1) {
      getAllRecentActivities();
      setHasMore(page < totalPages);
    }
  }, [page]);

  const fetchMoreData = () => {
    setPage((p) => p + 1);
  };
  return (
    <div className='py-6 h-full px-4 flex flex-col'>
      {loading ? (
        <PageText text='loading...' />
      ) : (
        <Fragment>
          <div className='brand_container'>
            <p className='text-sm font-medium mb-4 mt-6'>Recent Activities</p>
          </div>
          <div className='grow'>
            <InfiniteScroll
              dataLength={activities.length}
              next={() => fetchMoreData()}
              hasMore={hasMore}
              height='75vh'
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }>
              {activities.map((activity, index) => (
                <RecentActivityCard key={index} data={activity} />
              ))}
            </InfiniteScroll>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default RecentActivities;
